export const fonts = {
    body: 'Body Regular, sans-serif, -apple-system, BlinkMacSystemFont, Helvetica, Arial',
    heading: 'Heading Bold, sans-serif',
    mono: 'Menlo, monospace'
}
